   <template>
       <footer  style="height: 506px;display: none;">
      <div class="fot_box ban" style="height: 400px;">
        <div class="fot_logo" style="width: 228px;">
          <div class="logo_bot">
            <img src="../../assets/img/logo_bot.png" alt="" />
          </div>
          <div class="erweima" style="margin-top: 140px;">
            <img src="../../assets/img/erweima1.png" alt="" />
            <h6 class="erweima_text">{{ $t('locale.wechat') }}</h6>
          </div>
        </div>
        <div class="fot_mid" style="height: 370px;">
          <li>
            <dt>{{ $t('locale.about') }}</dt>
            <dd><a href="/page/about">{{ $t('locale.about1') }}</a></dd>
            <dd><a href="/page/about-culture">{{ $t('locale.about_culture') }}</a></dd>
            <dd><a href="/page/about-step">{{ $t('locale.about_step') }}</a></dd>
            <dd><a href="/page/about-productive">{{ $t('locale.about_productive') }}</a></dd>
            <dd><a href="/page/about-authority">{{ $t('locale.about_authority') }}</a></dd>
            <dd><a href="/page/about-partner">{{ $t('locale.about_partner') }}</a></dd>
          </li>
          <li>
            <dt>{{ $t('locale.Commercial_retail') }}</dt>
            <dd><a href="/page/schj">{{ $t('locale.shelves') }}</a></dd>
            <dd><a href="/page/hyzmchj">{{ $t('locale.store_shelves') }}</a></dd>
            <dd><a href="/page/zsdj">{{ $t('locale.stage') }}</a></dd>
            <dd><a href="/page/gwc">{{ $t('locale.car') }}</a></dd>
          </li>
          <li>
            <dt>{{ $t('locale.warehousing_industry') }}</dt>
            <dd><a href="/page/hlshj">{{ $t('locale.beam_type_shelves') }}</a></dd>
            <dd><a href="/page/hlshj?type=2">{{ $t('locale.narrow_roadway_beam_shelves') }}</a></dd>
            <dd><a href="/page/hlshj?type=3">{{ $t('locale.double_depth_beam_shelves') }}</a></dd>
            <dd><a href="/page/mjcchj">{{ $t('locale.drive_in_shelves') }}</a></dd>
            <dd><a href="/page/mjcchj?type=2">{{ $t('locale.shuttle_shelves') }}</a></dd>
            <dd><a href="/page/gyhj">{{ $t('locale.flow_shelves') }}</a></dd>
            <dd><a href="/page/gyhj?type=2">{{ $t('locale.cantilever_rack_shelves') }}</a></dd>
            <dd><a href="/page/gyhj?type=3">{{ $t('locale.duty_racking_shelves') }}</a></dd>
            <dd><a href="/page/gyhj?type=4">{{ $t('locale.attic_shelves') }}</a></dd>
            <dd><a href="/page/lthj">{{ $t('locale.vertical_warehouse_shelves') }}</a></dd>
            <dd><a href="/page/wlsb">{{ $t('locale.logistics_equipment') }}</a></dd>
          </li>
          <!--<li>
            <dt>{{ $t('locale.solution') }}</dt>
            <dd><a href="/page/retail">{{ $t('locale.retail') }}</a></dd>
            <dd><a href="/page/stage">{{ $t('locale.stage') }}</a></dd>
            <dd><a href="/page/storage">{{ $t('locale.storage') }}</a></dd>
            <dd><a href="/page/vending">{{ $t('locale.vending') }}</a></dd>
          </li>-->
          <li>
            <dt>{{ $t('locale.contactus') }}</dt>
            <dd><a href="/page/contact">{{ $t('locale.contact') }}</a></dd>
            <dd><a href="/page/jobs">{{ $t('locale.jobs') }}</a></dd>
            <dd><a href="/page/agent">{{ $t('locale.agent') }}</a></dd>
            <dd><a href="/page/supplier">{{ $t('locale.supplier') }}</a></dd>
          </li>
          <li>
            <dt>{{ $t('locale.server') }}</dt>
            <dd><a href="/page/serve">{{ $t('locale.serve') }}</a></dd>
            <dd><a href="/page/serve-shop">{{ $t('locale.serve_shop') }}</a></dd>

          </li>
          <div class="footer_login">
            <li>
              <i class="foot_login"></i>
              <a href="/page/register">{{ $t('locale.register') }}
              </a>
              <span>/</span>
              <a href="/page/login">{{ $t('locale.login') }}</a>
            </li>
            <li>
              <i class="fot_map"></i>
              <a href="javascript:;" data-locale="zh" class="js-locale">简体中文</a>
              <span>/</span>
              <a href="javascript:;" data-locale="en" class="js-locale">English</a>
            </li>
          </div>
        </div>
        <div class="fot_icon" style="width: 162px;">
          <dt>{{ $t('locale.online_shop') }}</dt>
          <dd class="car_icon"></dd>
          <dd><a href="/mall/goods.html">{{ $t('locale.sh_shop') }}</a></dd>
          <!--<dd class="sheji_icon"></dd>
          <dd><a href="/page/design" target="blank">{{ $t('locale.design') }}</a></dd>-->
          
        </div>
      </div>
      <div class="foot ban">
        <span>{{ $t('locale.copyright') }} Copyright</span><i class="foot_icon"></i><span>2020 {{ $t('locale.companyname') }} </span
        ><span>|</span><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank"> {{ $t('locale.icpno') }}</a><span>|</span
        ><span> {{ $t('locale.zgw') }} </span>
      </div>
    </footer>
</template>

<script>
export default {
  name: 'cell',
  data () {
    return {
      msg: '我是多页面 的 cell  页面'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ban{
    width: 1200px;
    margin: 0 auto;
}
footer {
  width: 100%;
  height: 418px;
    background:rgba(39,39,39,1);
    overflow: hidden;
    padding-top: 48px;
}
.fot_box{
position: relative;
height: 277px;
display: flex;
border-bottom: 1px solid rgba(159,160,160,1);
}
.fot_logo{
width: 258px;
height: 100%;

}
.fot_logo .logo_bot{
width: 166px;
height: 53px;
margin-left: 17px;
}
.fot_logo .erweima{
width: 96px;
height: 124px;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
margin-top: 75px;
margin-left: 52px;
}
.erweima_text{
font-size:14px;
font-family:SourceHanSansCN-Regular,SourceHanSansCN;
font-weight:400;
color:rgba(159,160,160,1);
line-height:21px;
margin-top: 16px !important;
}
.fot_mid{

width: 808px;
height: 216px;
border-left: 1px solid rgba(159,160,160,1);
border-right: 1px solid rgba(159,160,160,1);
display: flex;
justify-content: space-around;
}
.fot_mid li{
height: 100%;
text-align: center;
}
.fot_mid li dt{
font-size:14px;
font-family:SourceHanSansCN-Medium,SourceHanSansCN;
font-weight:500;
color:rgba(255,255,255,1);
line-height:21px;
margin-bottom: 20px;
}
.fot_mid li dd{
margin-bottom: 10px;
}
.fot_mid li dd a{
font-size:14px;
font-family:SourceHanSansCN-Regular,SourceHanSansCN;
font-weight:400;
color:rgba(159,160,160,1);
line-height:21px;
}
.fot_icon{
width: 132px;
height: 216px;
display: flex;
flex-direction: column;
align-items: center;
}
.fot_icon a{
color:rgba(159,160,160,1);

}
.fot_icon dt{
font-size:14px;
font-family:SourceHanSansCN-Regular,SourceHanSansCN;
font-weight:400;
color:rgba(255,255,255,1);
line-height:21px;
margin-bottom: 12px;
}
.fot_icon dd{
font-size:14px;
font-family:SourceHanSansCN-Regular,SourceHanSansCN;
font-weight:400;
color:rgba(159,160,160,1);
line-height:21px;
}
.car_icon{
width: 37px;
height: 36px;
background: url(../../assets/img/car_icon.png) no-repeat;
background-size: 37px 36px;
margin-bottom: 16px;
}
.sheji_icon{
width: 56px;
height: 32px;
background: url(../../assets/img/sheji_icon.png) no-repeat;
background-size: 56px 32px;
margin-bottom: 19px;
margin-top: 25px;
}
.footer_login{
    position: absolute;
    right: 0;
    bottom: 4px;
}
.footer_login li{
text-align: center;
font-size:14px;
font-family:SourceHanSansCN-Regular,SourceHanSansCN;
font-weight:400;
color:rgba(159,160,160,1);
line-height:21px;
display: block;
margin-bottom: 20px;
}
.footer_login li:nth-child(2){
margin-left: 42px;
}
.footer_login li a{
font-size:14px;
font-family:SourceHanSansCN-Regular,SourceHanSansCN;
font-weight:400;
color:rgba(159,160,160,1);
line-height:21px;
}
.foot_login{
display: inline-block;
width: 21px;
height: 20px;
background: url(../../assets/img/foot_login.png) no-repeat;
background-size: 21px 20px;
margin-right: 7px;
}
.fot_map{
display: inline-block;
width: 21px;
height: 21px;
background: url(../../assets/img/foot_map.png) no-repeat;
background-size: 21px 21px;
margin-right: 7px;

}
.foot{
margin-top: 18px  !important;
text-align: left;
}
.foot_icon{
display: inline-block;
width: 12px;
height: 12px;
background: url(../../assets/img/fot_icon.png) no-repeat;
background-size: 12px 12px;
margin: 0 3px;
}
.foot span{
font-size:14px;
font-family:SourceHanSansCN-Regular,SourceHanSansCN;
font-weight:400;
color:rgba(159,160,160,1);
line-height:21px;
}
dd{
    margin-left: 0;
}
.footer_login i{
    position: relative;
    top: 5px;
  }
</style>
   
   
   


// WEBPACK FOOTER //
// src/components/common/bottom.vue